import type {
    RxPlugin
} from '../../types';
import { startCleanupForRxCollection } from './cleanup';

export const NxDBCleanupPlugin: RxPlugin = {
    name: 'cleanup',
    nxdb: true,
    prototypes: {},
    hooks: {
        createRxCollection: {
            after: (i) => {
                startCleanupForRxCollection(i.collection);
            }
        }
    }
};

export * from './cleanup';
